export const PROPERTY_REPORT_MAP_SEARCH_BY = 'property_report_map' as const;

export interface IPropertyReportMapImpressionEvent {
  event_name: 'report_element_engagement';
  type: 'property_report_map_impression';
  report_type: 'property';
  search_by: typeof PROPERTY_REPORT_MAP_SEARCH_BY;
}

export interface IPropertyReportMapCardClickEvent {
  event_name: 'report_element_engagement';
  type: 'property_report_map_card_click';
  report_type: 'property';
  search_by: typeof PROPERTY_REPORT_MAP_SEARCH_BY;
  property_id: string;
  is_subject: boolean;
}

export interface IPropertyReportMapViewReportEvent {
  event_name: 'report_element_engagement';
  type: 'property_report_map_view_report';
  report_type: 'property';
  search_by: typeof PROPERTY_REPORT_MAP_SEARCH_BY;
  property_id: string;
}

/**
 * GA4 payload when the property map variation route is shown.
 */
export const buildPropertyReportMapImpressionEvent =
  (): IPropertyReportMapImpressionEvent => ({
    event_name: 'report_element_engagement',
    type: 'property_report_map_impression',
    report_type: 'property',
    search_by: PROPERTY_REPORT_MAP_SEARCH_BY,
  });

/**
 * GA4 payload when a map card or parcel pin is selected.
 */
export const buildPropertyReportMapCardClickEvent = (
  propertyId: string,
  isSubject: boolean
): IPropertyReportMapCardClickEvent => ({
  event_name: 'report_element_engagement',
  type: 'property_report_map_card_click',
  report_type: 'property',
  search_by: PROPERTY_REPORT_MAP_SEARCH_BY,
  property_id: propertyId,
  is_subject: isSubject,
});

/**
 * GA4 payload when the user opens a property report from the map.
 */
export const buildPropertyReportMapViewReportEvent = (
  propertyId: string
): IPropertyReportMapViewReportEvent => ({
  event_name: 'report_element_engagement',
  type: 'property_report_map_view_report',
  report_type: 'property',
  search_by: PROPERTY_REPORT_MAP_SEARCH_BY,
  property_id: propertyId,
});
